import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CloneProjectDto, ProjectDto } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'clone-project-dialog',
    templateUrl: './clone-project-dialog.component.html',
    styleUrls: ['./clone-project-dialog.component.scss'],
    standalone: false
})
export class CloneProjectDialogComponent implements OnInit {

  cloneProjectForm!:UntypedFormGroup;
  _db!:string;

  constructor(private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<CloneProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private tenantService: TenantService,
    private notificationService: NotificationService
    ) { }

  ngOnInit(): void {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((role: string) => {
            if (role === 'admin') {
              this._db = role;
            }
          });
        }
      }
    });
    this.createcloneProjectForm();
  }

  createcloneProjectForm(){
    this.cloneProjectForm = this.formBuilder.group({
      id:  this.data[0].id,
      //legacyId: this.data[0].legacyProjectId,
      name: [null, Validators.required],
      copyUsers: false,
      copyGrouproles: true,
      withContent: true,
      url: this.data[0].url
    });
  }

  createCloneProject(){

    if(this.cloneProjectForm.valid) {

          let cloneProject = new CloneProjectDto();
          cloneProject.projectId = this.cloneProjectForm.value.id;
          cloneProject.name = this.cloneProjectForm.value.name;
          cloneProject.url = this.cloneProjectForm.value.url;
          cloneProject.inclProjGroupRoles = this.cloneProjectForm.value.copyGrouproles;
          cloneProject.inclProjUsers = this.cloneProjectForm.value.copyUsers;
          cloneProject.inclContent = this.cloneProjectForm.value.withContent;
          console.log("============> cloneProject=", cloneProject)
          this.notificationService.wait(undefined, "Projekt wird kopiert ....");
          this.tenantService.cloneProject(this.tenantService.currentTenantName, cloneProject).subscribe({
              next:(project) => {
                this._dialogRef.close(this.cloneProjectForm.value);
                //console.log("=====> cloned project = ",project)
                // this.params.data.push(project);
                //this.params.api.refreshInfiniteCache();
                // this.refresh(this.params);
                //this.params.api.applyTransaction({ add: [project] });
                //this.params.api.redrawRows();
                //this.params.onClick(this.params);
                this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTCLONED"]} `);
              },
              error: (error: any) => {
                //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`);
                error.error = (cloneProject.inclContent) ? error.error + "copyProject" : error.error + "createProject";
                console.log("=====> cloneProject error = ", error.error)
                if (error.error != null) {
                  this.notificationService.error(`${this.translate.data["ERROR"]}`, `${error.error}`);
                }
              }
          })   
    }
  }

  isFormValid(){
    return this.cloneProjectForm.valid && (this.cloneProjectForm.value.copyUsers || this.cloneProjectForm.value.copyGrouproles || this.cloneProjectForm.value.withContent);
  }

  cancel() {
    this._dialogRef.close();
  }
}